import React from 'react';
import cx from 'classnames';
import Tooltip from '@zg-rentals/multibrand-ui/lib/Tooltip';
import InformationCircleIcon from '@zg-rentals/multibrand-ui/lib/icons/InformationCircle';

type Props = {
  className: string;
  IconComponent: any;
  iconName: string;
};

class StyledTooltip extends React.Component<React.PropsWithChildren<Props>> {
  static defaultProps = {
    className: '',
    IconComponent: InformationCircleIcon,
  };

  render() {
    const { IconComponent } = this.props;
    return (
      <Tooltip trigger="click" position="top" type="primary" className={cx('phs', this.props.className)}>
        <Tooltip.Target>
          <IconComponent size="sm" colorType="text-secondary" />
        </Tooltip.Target>
        {this.props.children}
      </Tooltip>
    );
  }
}

export default StyledTooltip;
